import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {CurrencyPipe, NgForOf, NgIf, NgSwitch, NgSwitchCase} from '@angular/common';
import {PlanService} from '../../services/plan.service';
import {RegionService} from '../../services/region-service';
import {Product} from '../../models/product';
import {Region} from '../../models/region';
import {identity, map, Subject, takeUntil} from 'rxjs';
import {StorageService} from '../../services/storage-service';
import {MoneyPipe} from '../pipes/money.pipe';
import {CurrencySymbolPipe} from '../pipes/currency-symbol.pipe';
import {Router, RouterLink} from '@angular/router';
import {FormsModule} from '@angular/forms';
import moment from "moment";

@Component({
  selector: 'app-pricing-boxes',
  imports: [
    NgSwitch,
    NgIf,
    NgSwitchCase,
    NgForOf,
    FormsModule,
    MoneyPipe,
    CurrencySymbolPipe
  ],
  providers: [CurrencyPipe],
  templateUrl: './pricing-boxes.component.html',
  styleUrl: './pricing-boxes.component.scss'
})
export class PricingBoxesComponent implements OnInit, OnDestroy {
  onDestroy$ = new Subject<boolean>();

  @Input() regionSlug: string | null = null
  @Input() isHideRegionSelection = false

  // Regions
  regions: Region[] = [];

  // Products
  products: Product[] = [];

  // Promotion
  promotionCode: string | null = null;

  loading = false;

  constructor(private router: Router,
              private regionService: RegionService,
              private planService: PlanService,
              private storageService: StorageService) {
  }

  async ngOnInit() {
    // Get region based on component input

    // Get region based on local storage
    if (!this.regionSlug) {
      this.regionSlug = this.storageService.get('region') || 'new-york';
    }

    this.promotionCode = this.storageService.get("promotionCode") || null;

    this.loading = true;
    await this.refreshRegions();
    await this.refreshProducts();
    this.loading = false;
  }

  ngOnDestroy() {
    this.onDestroy$.next(true);
    this.onDestroy$.complete();
  }

  async refreshRegions() {
    return this.regionService.findRegions()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe(data => {
        this.regions = data
      })
  }

  async refreshProducts() {
    if (this.regionSlug == null) return;

    return this.planService.getByRegion(this.regionSlug).pipe(
      takeUntil(this.onDestroy$),
      map(plan => plan.products || []),
      map(products => products
        .filter(product => product.membershipProperties!.code != 'plain')))
      .subscribe(data => this.products = data)
  }

  selectProduct(product: Product) {

    // Store the product in storage
    this.storageService.add(StorageService.PROMOTION_CODE, this.promotionCode);
    this.storageService.add(StorageService.PRODUCT_SLUG, product.slug);

    // Go to join page
    this.router.navigate(['/join']).then();
  }

  selectRegion() {

    // Store the region in storage
    this.storageService.add(StorageService.REGION_SLUG, this.regionSlug);

    this.refreshProducts()
  }

  protected readonly identity = identity;
}
